module.exports = __webpack_public_path__ + "static/img/year-in-review.2c3b46a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company-performance/year-in-review.jpg
// module id = uuvG
// module chunks = 0